module.exports = __webpack_public_path__ + "static/media/close.aef654b3.svg";